import { configureStore } from '@reduxjs/toolkit';
import { contentReducers } from 'redux/content';
import { languageReducer } from 'redux/language';

/**
 * Сховище складається з двох частин.
 *
 * contentReducers — розділи CMS: новини, заходи, документи, керівництво,
 * організації, історія. Усі однакової форми { data, status, error, locale },
 * тому сторінки читають їх через один хук useContent.
 *
 * Поруч — мова інтерфейсу: від неї залежить і текст на екрані, і локаль, якою
 * запитуються ті самі розділи.
 *
 * Реєстру e-phan тут більше немає (ADR-0015): його читає одна сторінка, тож
 * стан живе в ній самій — див. hooks/useRegistryList. У сховищі лишилося те,
 * що справді спільне для кількох екранів.
 */
/**
 * Окреме сховище на виклик. Застосунку потрібне одне на всю сторінку (нижче),
 * а тестам — своє на кожну перевірку, інакше стан однієї протікає в наступну.
 */
export function createAppStore(preloadedState) {
  return configureStore({
    reducer: {
      ...contentReducers,
      language: languageReducer,
    },
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
      }),
  });
}

const store = createAppStore();

export default store;
